import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Page, ScenarioDeploy, ScenarioRestoreBody } from "@/model";
import deployRepository from "@/repository/deployRepository";
import { deploymentQueryKeys } from "./keys";


export const useRestoreScenarioDeploy = (scenarioId: string) => {
    const queryClient = useQueryClient();
    
    return useMutation<Page<ScenarioDeploy>, Error, ScenarioRestoreBody>({
        mutationKey: ['scenario-deploy', scenarioId, 'restore'],
        mutationFn: async ({ deployId, description }) => {
            const response = await deployRepository.restore(
                scenarioId, 
                deployId,
                description
            );
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ 
                    queryKey: deploymentQueryKeys.pageAll(scenarioId) 
                }),
                queryClient.invalidateQueries({ 
                    queryKey: deploymentQueryKeys.diffAll(scenarioId) 
                })
            ]);
        }
    });
};
